// extracted by mini-css-extract-plugin
export default {"stepLabel":"step-label_stepLabel__ZaTWx","completed":"step-label_completed__IKZXs"};